/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスキットガイドラインのテキスト
 * @export
 * @interface PressKitGuidelineText
 */
export interface PressKitGuidelineText {
    /**
     * テキストで書かれたガイドライン。指定がない場合は''
     * @type {string}
     * @memberof PressKitGuidelineText
     */
    content: string;
}

/**
 * Check if a given object implements the PressKitGuidelineText interface.
 */
export function instanceOfPressKitGuidelineText(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function PressKitGuidelineTextFromJSON(json: any): PressKitGuidelineText {
    return PressKitGuidelineTextFromJSONTyped(json, false);
}

export function PressKitGuidelineTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitGuidelineText {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function PressKitGuidelineTextToJSON(value?: PressKitGuidelineText | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
    };
}

